export enum BaseSizes {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  '2xl' = '2xl',
  '3xl' = '3xl',
  '4xl' = '4xl'
}

export enum DeviceSizes {
  sm = 'Sm',
  md = 'Md',
  lg = 'Lg',
  xl = 'Xl',
  xl2 = '_2xl'
}
